import React, { useEffect } from 'react';
import { useFireAgencyContext } from 'src/contexts/fire-agency.context';
import { actionTypes } from 'src/ducks/fire-agency.duck';
import { getFireAgencyStatus } from 'src/selectors/fire-agency.selector';
import FireAgenciesView from './fire-agencies-list.view';

const FireAgencies: React.FC = () => {
  const { state, actions } = useFireAgencyContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <FireAgenciesView
      loading={
        getFireAgencyStatus(state, actionTypes.FIRE_AGENCY_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default FireAgencies;
